<template>
	<div class="form-control home-banner-search">
		<span class="input-container">
			<input 
				class="form-input home-banner-input"
				type="text"
				v-bind="$attrs"
				:value="value"
				@keyup.enter="searchThisProduct"
				@blur="closeSearchingMenu"
				@input="textTosearch"
			>
			<span class="loading" v-if="isLoading">Buscando...</span>
		</span>
		<span
			class="no-products-message"
			v-if="noProducts"
		>no hay resultados para esa búsqueda</span>
		<div
			class="searching-menu"
			v-if="showSearchingMenu"
		>
			<section
				v-for="(item, indexItem) in itemFinded"
				:key="indexItem"
			>
				<h3 class="searching-title">{{item.type}}</h3>
				<p
					class="searching-result"
					v-for="(product, indexProduct) in item.contents"
					:key="indexProduct"
					@click="gotToThisProductPage(product)"
				>{{product.title}}</p>
			</section>
			<hr class="separater" v-if="showSeparater">
		</div>
		<img src="/static/img/buscador.svg" alt="image-buscador" class="image-buscador">
	</div>
</template>
<script>

function showSeparater() {
	return this.itemFinded.length > 1;
}

function textTosearch($event) {
	this.noProducts = false;
	this.$emit('input', $event.target.value);
}


function gotToThisProductPage(product) {
	const id = product ? product.id : null;
	this.$emit('search', id);
}

function closeSearchingMenu() {
	if (!this.value) {
		this.showSearchingMenu = false;
	}
}

function searchThisProduct(event) {
	const val = event.target.value;
	this.noProducts = false;
	this.makeSearchingRequest(val);
}

async function makeSearchingRequest(val) {
	this.isLoading = true;
	const codeApp = process.env.APP_CODE;
	const urlProducts = `${process.env.ARIS_URL}/app/${process.env.APP_CODE}/products`;
	const url = val ? `/company/app/${codeApp}` : urlProducts;
	const params = {};
	if (val) {
		params.search = val;
	} else {
		delete params.search;
	}
	const { data: response } = await this.$http.get(url, { params });
	if (response.data) {
		this.itemFinded = { ...response.data };
		this.showSearchingMenu = true;
	} else {
		this.noProducts = !response.data;
	}
	if (!val) {
		this.showSearchingMenu = false;
		this.gotToThisProductPage();
	}
	this.isLoading = false;
}

function data() {
	return {
		itemFinded: [],
		isLoading: false,
		noProducts: false,
		productPageName: 'page-product',
		showSearchingMenu: false,
		tipsPageName: 'page-tips',
	};
}

export default {
	name: 'searching-input',
	computed: {
		showSeparater,
	},
	data,
	inheritAttrs: false,
	methods: {
		closeSearchingMenu,
		gotToThisProductPage,
		makeSearchingRequest,
		searchThisProduct,
		textTosearch,
	},
	props: {
		value: null,
	},
};
</script>
<style lang="scss" scoped>
.home-banner-search {
	max-width: 543px;
	position: relative;
}

.home-banner-input {
	background: rgba(0, 0, 0, 0.31);
	border: 1px solid map-get($colors, white);
	border-radius: 12px;
	color: map-get($colors, white);
	height: 50px;
	width: 100%;
}

.home-banner-input::placeholder {
	color: map-get($colors, white);
}

.searching-menu {
	background-color: color(white);
	border-radius: 12px;
	left: 0;
	max-height: 200px;
	overflow: scroll;
	padding: 25px 18px;
	position: absolute;
	top: 50px;
	width: 100%;
	z-index: 9;
}


.searching-title {
	color: color(black-dark);
}

.separater {
	border: 1px solid color(black-dark);
}

.searching-result {
	cursor: pointer;
	height: 30px;
}

.searching-result:hover {
	background-color: color(grey-text);
}

.image-buscador {
	position: absolute;
	left: 85%;
	top: 15px;
}

.no-products-message {
	color: color(red-dark);
}

.input-container {
	position: relative;
}

.loading {
	height: 100%;
	position: absolute;
	right: 0;
	text-align: center;
	top: 0;
	width: 100%;
}

@media screen and (max-width:884px) {
	.product-search {
		width: 84%;
	}
}
</style>




// WEBPACK FOOTER //
// src/components/commons/searching-input.vue